var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-text",
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c("v-col", { attrs: { cols: "4" } }, [
                _c("p", { staticClass: "text-caption" }, [
                  _vm._v("Edit values or paste them."),
                ]),
              ]),
              _c("v-spacer"),
              _c(
                "v-col",
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      width: "90",
                                      height: "30",
                                      small: "",
                                      outlined: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyValues()
                                      },
                                    },
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-content-copy"),
                                  ]),
                                  _vm._v(" Copy "),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Copy values")])]
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-col",
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  {
                                    attrs: {
                                      width: "90",
                                      height: "30",
                                      small: "",
                                      outlined: "",
                                    },
                                    on: { click: _vm.pasteValues },
                                  },
                                  on
                                ),
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-content-paste"),
                                  ]),
                                  _vm._v(" Paste "),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Paste values")])]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-simple-table", {
            attrs: { dense: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function () {
                  return [
                    _c("thead", [
                      _c(
                        "tr",
                        _vm._l(_vm.headers, function (header, headerIndex) {
                          return _c(
                            "th",
                            {
                              key: "header-" + headerIndex,
                              staticClass: "text-left",
                            },
                            [_vm._v(" " + _vm._s(header.name) + " ")]
                          )
                        }),
                        0
                      ),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.tableValue, function (row, rIndex) {
                        return _c(
                          "tr",
                          { key: "row-" + rIndex },
                          _vm._l(_vm.headers, function (header, hIndex) {
                            return _c(
                              "td",
                              { key: "col-" + hIndex },
                              [
                                header.editable
                                  ? _c("v-text-field", {
                                      ref: "val-row-" + rIndex,
                                      refInFor: true,
                                      attrs: {
                                        type: "number",
                                        step: "0.001",
                                        dense: "",
                                        "hide-details": "",
                                        "hide-spin-buttons": "",
                                        variant: "plain",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.parseValue(
                                            $event,
                                            rIndex,
                                            hIndex
                                          )
                                        },
                                      },
                                      model: {
                                        value: row[hIndex],
                                        callback: function ($$v) {
                                          _vm.$set(row, hIndex, $$v)
                                        },
                                        expression: "row[hIndex]",
                                      },
                                    })
                                  : [_vm._v(_vm._s(row[hIndex]))],
                              ],
                              2
                            )
                          }),
                          0
                        )
                      }),
                      0
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { text: "", color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _c(
            "v-btn",
            {
              attrs: { text: "", color: "primary" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v("Save")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }